module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sink"
  }, [_c('code', {
    staticClass: "sans"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You thought you were a crystal stream, cleansed of debris, especially the vast store of facts and quotations you’d early acquired and later suppressed, so that you’d finally become exactly what the Old Man had so contemptuously called you, a “movie fan.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("But in truth you were a river of fear, clogged and murky, with your own dark undertow.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You know how deep this river ran by what has been dislodged from its silt-covered bottom, a whole world of buried reading.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You suddenly recall Tolstoy’s “Three Deaths.” You remember following the story through the first death, then the second, growing anxious as it nears its end and still there is no third death, nor even any character who seems destined to suffer it. Then a workman appears, an ax balanced on his shoulder, trudging across a cemetery toward a large tree. With the first blow of the ax you feel the great tree shudder. Its outspread limbs tremble in panic. You sense the tree’s terror in every quaking leaf. With each blow, it weakens, a life force "), _c('a', {
    attrs: {
      "id": "p2"
    }
  }), _vm._v("ebbing until the murdered tree finally groans, falls, becomes the tale’s third death.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("Now four deaths swirl around you like the splintered remnants of a stricken ship. You feel a hint of unexpected moisture on your fingertip, rising water at your ankles, a span of rain-drenched black wrought iron, a heavy limb.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("A guard appears, his badge muted by the dull gray light. Still, for a moment, you can focus on nothing but the badge. Then it flashes brightly, like a photographer’s bulb, and you wonder if that is how she saw it, blinding, and in some way unforgiving.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("The guard draws open the cell’s steel door.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("“Detective Petrie is ready for you now,” he says.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You rise from the cot, move across the concrete floor, then down the corridor and into a room where you expect to find Petrie waiting to hear your version of what happened. You have waived your rights, and will, according to your own counsel, tell your tale.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("But Detective Petrie is not yet in the room, so you take a moment to survey it, get your bearings as best you can. There is a card table with a coffee machine, its glass urn already full of coffee. A stack of Styrofoam cups rests next to the machine. There is a clock on the wall, and a calendar.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You walk to the window, and peer out at the small portion of the world that has held your little life like a pebble in its palm. You have "), _c('a', {
    attrs: {
      "id": "p3"
    }
  }), _vm._v("become a student of reenacted murders. You recall a TV movie about the Hillside Strangler, how the prosecutor took the jury to a hill, then had the light from a police helicopter move first to this spot, then that one, then that one over there, each where a body had been found. The last light illuminated the killer’s house, the grim geometric center of this carnage. Now you stare out the window and move your gaze like a spotlight from Victor Hugo Street to Dolphin Pond, to Carey Towers, to Salzburg Garden. You imagine long bands of yellow tape running from site to site, connecting supposed scenes of crime.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("“Mr. Sears.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You turn.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("Petrie steps into the room and closes the door behind him. “Have a seat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("He nods toward a table and two chairs. You notice a tape recorder, a notepad, a blue pen. You recognize these things as the usual instruments of interrogation, though you know you are surely not the usual suspect.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You walk to the table and sit down.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("Petrie sits down in the chair across from you, turns on the tape recorder, recites his name, your name, the date, time, location. He is dressed very neatly, everything in place, jacket buttoned, the knot of his tie pulled tight and straightened, a cool professional, convinced he has heard it all, will not be jarred by what you have to tell him.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("“Ready?” he asks.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You don’t know where to begin. There is so much to tell, so many currents in the river.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("“Ready?” Petrie repeats.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("A woman’s voice chants in your mind.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('code', {
    staticClass: "sans"
  }, [_c('em', [_vm._v("Father/Sister")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Twister.")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Father/Daughter")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Slaughter.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("You are a river of fear, with bodies circling in the still-churning water. You are at the tragic terminus of this river and must now return to its origin.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("“Where do you want me to begin?” you ask.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("Petrie appears as solid and impenetrable as unweathered stone. “Choose your own starting point,” he says.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('code', {
    staticClass: "sans"
  }, [_vm._v("And so you do.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-234a0574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c001.vue
// module id = 72
// module chunks = 0